import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const CreateJobIndex = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.CREATE_POSITION}/${ROUTE_KEYS.CREATE_POSITION_FORM_DETAILS}`, {
      replace: true
    });
  }, []);
  return <div />;
};

export default CreateJobIndex;
